// Shared source of truth for the daily "compass direction" the Soul tab
// surfaces. Deterministic by day-of-year so every member sees the same
// direction on the same day, and it rotates gently through four cardinal
// points on a repeating cycle.
export const COMPASS_DIRECTIONS = [
  {
    slug: "north",
    label: "North",
    theme: "Intuition",
    tone: "Soft, Inward, Reflective",
    message: "Your inner voice is louder than the noise. Trust it.",
    footer: "Your compass points North — choose words that strengthen your knowing.",
    // Small vector to rotate the compass needle to on the entry card orb.
    angle: 0,
  },
  {
    slug: "east",
    label: "East",
    theme: "Expansion",
    tone: "Bright, Curious, Open",
    message: "Step forward. New light is meeting you.",
    footer: "Your compass points East — let curiosity lead the next small step.",
    angle: 90,
  },
  {
    slug: "south",
    label: "South",
    theme: "Grounding",
    tone: "Warm, Steady, Rooted",
    message: "Return to your body. Return to now.",
    footer: "Your compass points South — root into the moment before you move.",
    angle: 180,
  },
  {
    slug: "west",
    label: "West",
    theme: "Release",
    tone: "Quiet, Softening, Letting go",
    message: "What you release makes room for what's real.",
    footer: "Your compass points West — release what is no longer yours to carry.",
    angle: 270,
  },
];

export function currentCompassDirection(now = new Date()) {
  const start = new Date(now.getFullYear(), 0, 0);
  const diff = now - start;
  const dayOfYear = Math.floor(diff / (1000 * 60 * 60 * 24));
  return COMPASS_DIRECTIONS[dayOfYear % COMPASS_DIRECTIONS.length];
}
